module.exports = __webpack_public_path__ + "img/attack_electricball_red.47e4d605.png";